const navigation = () => {
  const sitePage = document.getElementById('page');
  const body = document.getElementsByTagName("body")[0];
  let site, masthead, container, button, menu, menuWrap, links, i, len;
  site = document.getElementById('page');
  if (!site) {
    return;
  }
  site.setAttribute('aria-expanded', 'false');

  masthead = document.getElementById('masthead');
  if (!masthead) {
    return;
  }
  masthead.setAttribute('aria-expanded', 'false');

  container = document.getElementById('site-navigation');
  if (!container) {
    return;
  }

  // button = container.getElementsByTagName('button')[0];
  button = document.querySelector('.menu-toggle');
  if ('undefined' === typeof button) {
    return;
  }

  menu = container.getElementsByTagName('ul')[0];
  // Hide menu toggle button if menu is empty and return early.
  if ('undefined' === typeof menu) {
    button.style.display = 'none';
    return;
  }

  menu.setAttribute('aria-expanded', 'false');
  if (-1 === menu.className.indexOf('nav-menu')) {
    menu.className += ' nav-menu';
  }

  button.onclick = function () {
    if (-1 !== container.className.indexOf('toggled')) {
      container.className = container.className.replace(' toggled', '');
      button.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-expanded', 'false');
      masthead.setAttribute('aria-expanded', 'false');
      site.setAttribute('aria-expanded', 'false');
      body.classList.remove('freeze');
    } else {
      container.className += ' toggled';
      button.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-expanded', 'true');
      masthead.setAttribute('aria-expanded', 'true');
      site.setAttribute('aria-expanded', 'true');
      body.classList.add('freeze');
      // top menu fixed
      // var mobileMenuTop = masthead.clientHeight - 1;
      // var mobileMenu = document.querySelector('.mobile-menu');
      // mobileMenu.style.top = mobileMenuTop + 'px';
      // mobileMenu.style.paddingBottom = mobileMenuTop + 'px';
    }
  };

  var subMenus = document.querySelectorAll('.nav-menu > .has-sub');
  var subMenusButtons = document.querySelectorAll('.nav-menu > .has-sub > .btn-arrow');
  if (subMenusButtons.length > 0) {
    for (var j = 0; j < subMenusButtons.length; j++) {
      subMenusButtons[j].addEventListener('click', (e) => {
        e.preventDefault();
        if (-1 === e.currentTarget.parentNode.className.indexOf('active')) {
          for (var k = 0; k < subMenus.length; k++) {
            subMenus[k].classList.remove('active');
          }
          e.currentTarget.parentNode.classList.add('active');
        } else {
          e.currentTarget.parentNode.classList.remove('active');
        }
      });
    }
  }
};

export default navigation;
